import {User} from '../../../incase-domain/user';

export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const FETCH_LOGGED_IN_USER_ACTION = 'FETCH_LOGGED_IN_USER_ACTION';
export const LOGOUT_USER = 'LOGOUT_USER';
export const HAS_ERROR_ACTION = 'HAS_ERROR_ACTION';
export const SET_LOGIN_ERROR_MESSAGE = 'SET_LOGIN_ERROR_MESSAGE';

export interface ISetLoggedInUserAction {
    type: typeof SET_LOGGED_IN_USER;
    user: User;
}

export interface IFetchLoggedInUserAction {
    type: typeof FETCH_LOGGED_IN_USER_ACTION;
}

export interface ILogoutUserAction {
    type: typeof LOGOUT_USER;
}

export type AuthReducerType = ISetLoggedInUserAction | ILogoutUserAction;
